import React from "react";
import { NavLink } from "react-router-dom";

class AboutCompany2 extends React.Component {
  render() {
    return (
      <>
        <div className="section-full p-t80 bg-white">
          <div className="container">
            <div className="section-content ">
              <div className="m-service-containt text-black">
                <div className="row">
                  <div className="col-md-5 col-sm-12">
                    <div className="service-about-left">
                      <div className="mt-media">
                        <img
                          src={require("./../../images/extfile/cranes-are-lifting-materials-at-a-busy-constructio-2024-10-16-23-07-58-utc.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-7 col-sm-12">
                    <div className="service-about-right m-b30">
                      <h3 className="m-t0">Indoor Air Quality(IAQ)</h3>

                      <p>
                        At KUO ENTERPRISES LLP, our commitment to quality,
                        safety, and client well-being is at the core of
                        everything we do. We understand the importance of
                        maintaining clean, healthy air in indoor environments,
                        and we are dedicated to implementing solutions that
                        ensure optimal indoor air quality. Our HVAC expertise
                        focuses on creating safer, healthier, and more efficient
                        spaces by minimizing airborne contaminants and
                        maximizing energy efficiency.
                      </p>
                      <h4>Our IAQ Solutions:</h4>
                      <p>
                        <b>Reduction of Toxic Gases, Odors, and Smoke: </b>
                        We employ advanced filtration and ventilation systems to
                        significantly reduce harmful gases, unpleasant odors,
                        and smoke, creating a fresher and cleaner indoor
                        atmosphere.
                      </p>
                      <p>
                        <b>Elimination of Harmful Pathogens:</b>
                        Our systems achieve near-total elimination of fungi,
                        molds, microbes, and airborne bacteria within AC ducts,
                        promoting a safer, healthier indoor environment.
                      </p>
                      <p>
                        <b>Energy Efficiency and Cost Savings:</b>
                        Our solutions lead to substantial reductions in HVAC
                        plant capacity, which helps lower capital costs and
                        decrease ongoing operating expenses.
                      </p>
                      <p>
                        <b>Long-Term Savings:</b>
                        By optimizing energy usage, our solutions provide annual
                        savings on related components such as transformers,
                        standby generators, HT/LT panels, cabling, plant room
                        space, and water usage.
                      </p>
                      <h4>Why Choose KUO ENTERPRISES LLP for IAQ?</h4>
                      <p>
                        Certified for effectiveness and safety by national
                        standards, our IAQ solutions reflect our unwavering
                        dedication to quality and safety. At KUO ENTERPRISES
                        LLP, we foster a culture of continuous improvement,
                        adhering to industry best practices to deliver
                        reliability and durability. Our goal is to build a
                        healthier and safer environment for all through
                        innovative IAQ solutions that stand the test of time.
                      </p>
                      <div className="call-for-quote-outer">
                        <div className="call-quote">
                          <span>Call For a Quote:</span>
                          <h4> +91 8921197287, 9437630763</h4>
                        </div>
                        <div className="call-estimate bg-dark">
                          <NavLink
                            to={"#"}
                            className="site-button-secondry btn-effect"
                          >
                            Online Estimate Form
                          </NavLink>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default AboutCompany2;
